// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"778":"d36810c0","998":"d36810c0"}[chunkId] + ".chunk.css";
};